<script lang="ts">
    let className: string = "";

    export { className as class };
</script>

<div class="control rounded shadow {className}">
    <slot />
</div>
